export const spotType = value => {
    switch (value) {
        case 'pub':
            return 'pub & bar'
        case 'workshop':
        case 'shop':
            return 'workshop & shop'
        default:
            return value
    }
}

export const spotTypeShort = value => {
    switch (value) {
        case 'pub':
            return 'pub & bar'
        default:
            return value
    }
}

export const programType = value => {
    switch (value) {
        case 'dining':
            return 'local dining'
        default:
            return value
    }
}

export const programTypeKo = value => {
    const locale = {
        dining: '미식회',
        experience: '체험',
        concert: '콘서트',
        class: '클래스'
    }
    return locale[value]
}